module.exports = __webpack_public_path__ + "static/img/拉新裂变获客.a25cb15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/拉新裂变获客.png
// module id = FXzp
// module chunks = 0